import companyNoticeDetailsLocale from './en.json'

const en = {
  companyNoticeDetails: companyNoticeDetailsLocale,
}

export default en
